export const setAuthToken = () => {
  const token = localStorage.getItem("token");

  return `Bearer ${token}`;
};

export const getAuthTokenRaw = () => localStorage.getItem("token") ?? "";
